import { gql } from '@urql/core';

export const STRUCTURES_LIST_QUERY = gql`
    query GetStructures($page: Int, $perPage: Int, $sort: StructureSort, $organizationId: String) {
        structures(page: $page, perPage: $perPage, sort: $sort, organizationId: $organizationId) {
            totalCount
            nodes {
                name
                isAuthUserEditor
                createdAt
                id
                backgroundFileConvertUrl
                interactiveFileConvertUrl
                vectorStoreId
            }
        }
    }
`;

export const GET_STRUCTURE = gql`
    query GetStructure($id: ID!) {
        structure(id: $id) {
            name
            type
            backgroundFileConvertUrl
            backgroundFileConvertStatus
            interactiveFileConvertUrl
            interactiveFileConvertStatus
            backgroundStagedFileConvertStatus
            backgroundStagedFileConvertUrl
            interactiveStagedFileConvertStatus
            interactiveStagedFileConvertUrl
            finishingSchemeUrl
            floorNumber
            id
            isAuthUserEditor
            svgPolygonPath
            vectorStoreId
            vectorStoreCreatedAt
            ancestors {
                id
                name
                type
                vectorStoreId
            }
        }
    }
`;

export const GET_STRUCTURE_ORGANIZATIONS = gql`
    query GetStructureOrganizations($id: ID!, $organizationsPerPage: Int, $organizationsPage: Int) {
        structure(id: $id) {
            organizations(perPage: $organizationsPerPage, page: $organizationsPage) {
                totalCount
                nodes {
                    id
                    name
                }
            }
        }
    }
`;

export const GET_STRUCTURE_USERS = gql`
    query GetStructureUsers($id: ID!, $userPerPage: Int, $usersPage: Int, $sort: UserSort) {
        structure(id: $id) {
            users(perPage: $userPerPage, page: $usersPage, sort: $sort) {
                totalCount
                nodes {
                    id
                    fullName
                    email
                    organization {
                        name
                    }
                }
            }
        }
    }
`;

export const STRUCTURE_PREVIEW_QUERY = gql`
    query GetStructurePreview($id: ID!, $perPage: Int, $page: Int, $sort: StructureSort) {
        structure(id: $id) {
            interactiveFileConvertUrl
            backgroundFileConvertUrl
            backgroundFileConvertStatus
            interactiveFileConvertStatus
            finishingSchemeUrl
            svgPolygonPath
            floorNumber
            id
            name
            type
            description
            ancestors {
                id
                description
            }
            children(perPage: $perPage, page: $page, sort: $sort) {
                totalCount
                nodes {
                    id
                    name
                    floorNumber
                    svgPolygonPath
                    description
                    backgroundFileConvertUrl
                    interactiveFileConvertUrl
                    finishingSchemeUrl
                    type
                    ancestors {
                        id
                        name
                        description
                    }
                    reference {
                        id
                        name
                        svgPolygonPath
                        description
                        type
                        ancestors {
                            id
                            name
                        }
                    }
                }
            }
        }
    }
`;

export const GET_STRUCTURE_REFERENCES_QUERY = gql`
    query GetStructureReferences($id: ID!) {
        structure(id: $id) {
            id
            name
            reference {
                id
                name
                type
                ancestors {
                    id
                    name
                    type
                }
            }
            referenceBy {
                id
                name
                type
                ancestors {
                    id
                    name
                    type
                }
            }
            ancestors {
                id
                name
                type
            }
        }
    }
`;

export const GET_NESTED_STRUCTURE = gql`
    query GetNestedStructure($id: ID!, $sort: StructureSort, $perPage: Int, $page: Int) {
        structure(id: $id) {
            name
            id
            description
            backgroundFileConvertUrl
            backgroundFileConvertStatus
            interactiveFileConvertUrl
            interactiveFileConvertStatus
            backgroundStagedFileConvertStatus
            backgroundStagedFileConvertUrl
            interactiveStagedFileConvertStatus
            interactiveStagedFileConvertUrl
            svgPolygonPath
            finishingSchemeUrl
            type
            ancestors {
                name
                id
            }
            children(sort: $sort, perPage: $perPage, page: $page) {
                totalCount
                nodes {
                    name
                    floorNumber
                    svgPolygonPath
                    description
                    backgroundFileConvertUrl
                    interactiveFileConvertUrl
                    backgroundFileConvertStatus
                    interactiveFileConvertStatus
                    backgroundStagedFileConvertStatus
                    backgroundStagedFileConvertUrl
                    interactiveStagedFileConvertStatus
                    interactiveStagedFileConvertUrl
                    finishingSchemeUrl
                    id
                    type
                    ancestors {
                        name
                        id
                    }
                }
            }
        }
    }
`;

export const GET_NESTED_STRUCTURE_COUNT = `
  query GetNestedStructureCount($id: ID!) {
    structure(id: $id) {
      children {
        totalCount
      }
    }
  }
`;

export const STRUCTURES_REVISION_LIST_QUERY = gql`
    query GetStructureRevisionList(
        $id: ID!
        $page: Int
        $perPage: Int
        $sort: StructureRevisionsSort
    ) {
        structure(id: $id) {
            revisions(page: $page, perPage: $perPage, sort: $sort) {
                totalCount
                nodes {
                    id
                    createdAt
                    name
                    files {
                        id
                        fileName
                        fileUrl
                    }
                    structure {
                        id
                        svgPolygonPath
                    }
                }
            }
        }
    }
`;

export const GET_STRUCTURE_ANCESTORS = gql`
    query GetStructureAncestors($id: ID!) {
        structure(id: $id) {
            id
            name
            type
            ancestors {
                name
                id
                type
            }
        }
    }
`;

export const GET_CURRENT_MANAGE_STRUCTURE = gql`
    query GetCurrentManageStructure($id: ID!, $perPage: Int, $page: Int) {
        structure(id: $id) {
            id
            ancestors {
                id
            }
            children(perPage: $perPage, page: $page) {
                totalCount
                nodes {
                    name
                    id
                    svgPolygonPath
                    type
                    description
                    ancestors {
                        id
                    }
                }
            }
        }
    }
`;

export const GET_STRUCTURE_CHILDREN = gql`
    query GetStructureChildren($id: ID!, $sort: StructureSort, $perPage: Int, $page: Int) {
        structure(id: $id) {
            name
            id
            svgPolygonPath
            type
            children(sort: $sort, perPage: $perPage, page: $page) {
                totalCount
                nodes {
                    name
                    id
                    svgPolygonPath
                    type
                    floorNumber
                    ancestors {
                        name
                        id
                    }
                    reference {
                        id
                        name
                    }
                }
            }
        }
    }
`;
